(() => {
  const AUTOPLAY_MS = 5000;
  const SECTION_ID = '#shopify-section-template--21532652962045__carousel_nx9Hbw';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const section = document.querySelector(SECTION_ID);
  if (!section) return;

  const slider = section.querySelector('slideshow-component.carousel-content');
  if (!slider) return;

  const getScroller = () => slider.querySelector('slideshow-slides[ref="scroller"]');
  const getFirstCard = () => slider.querySelector('.card[data-carousel-card]');

  const getGapPx = () => {
    // Horizon met le gap en variable CSS sur le slideshow-component
    const raw = getComputedStyle(slider).getPropertyValue('--carousel-gap').trim();
    const n = parseFloat(raw.replace('px', ''));
    return Number.isFinite(n) ? n : 0;
  };

  const getStep = () => {
    const card = getFirstCard();
    if (!card) return 0;
    const w = card.getBoundingClientRect().width;
    return Math.round(w + getGapPx());
  };

  let timer = null;
  let paused = false;

  const next = () => {
    const scroller = getScroller();
    const step = getStep();
    if (!scroller || !step) return;

    const max = scroller.scrollWidth - scroller.clientWidth;

    // loop simple (retour au début)
    if (scroller.scrollLeft >= max - step * 0.5) {
      scroller.scrollTo({ left: 0, behavior: 'auto' });
      return;
    }

    scroller.scrollBy({ left: step, behavior: 'smooth' });
  };

  const start = () => {
    if (timer || paused) return;
    timer = setInterval(() => {
      if (document.hidden) return;
      next();
    }, AUTOPLAY_MS);
  };

  const stop = () => {
    if (!timer) return;
    clearInterval(timer);
    timer = null;
  };

  // Pause hover/touch
  slider.addEventListener('mouseenter', () => { paused = true; stop(); });
  slider.addEventListener('mouseleave', () => { paused = false; start(); });
  slider.addEventListener('touchstart', () => { paused = true; stop(); }, { passive: true });
  slider.addEventListener('touchend', () => { paused = false; start(); }, { passive: true });

  // Stop quand onglet inactif
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop();
    else start();
  });

  // Horizon hydrate parfois après le load → on attend que le scroller existe
  const boot = () => {
    if (getScroller() && getFirstCard()) start();
  };
  boot();

  const obs = new MutationObserver(() => {
    if (!timer && getScroller() && getFirstCard()) {
      start();
    }
  });
  obs.observe(slider, { childList: true, subtree: true });
})();